import { useState } from 'react'
import PartnerForm from './components/partner-form/PartnerForm'
import DonationForm from './components/donation-form/DonationForm'
import Header from './components/header/Header'
import Footer from './components/footer/Footer'
import main_style from './index.module.css'
import { GlobalProvider } from './context/formContext'

function App() {
  const [selectedHeader, setSelectedHeader] = useState('PartnerHeader')

  return (
    <GlobalProvider>
      <section className={main_style.body_section_container_page}>
        <main className={main_style.main_container_style_class}>
          <Header selectedHeader={selectedHeader} setSelectedHeader={setSelectedHeader} />
          <section>
            {selectedHeader === 'PartnerHeader' ? <PartnerForm /> : <DonationForm />}
          </section>
          <Footer />
        </main>
      </section>
    </GlobalProvider>

  )
}

export default App
